<template>
  <div class="bg-white rounded">
    <div class="flex flex-wrap items-cente p-6 justify-between items-center" :class="(headerBorder) ? 'border-b border-gray-300' : 'pb-0'" v-if="$slots.header">
      <h1 class="font-medium poppins w-full sm:w-2/3 mb-2 sm:mb-0">
        <slot name="header"></slot>
      </h1>
      <div class="w-auto" v-if="$slots.toolbar"><slot name="toolbar"></slot></div>
    </div>

    <div :class="contentPadding" v-if="$slots.content">
      <slot name="content"></slot>
    </div>

    <div class="px-6 py-4 border-t border-gray-300" v-if="$slots.footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    headerBorder: {
      type: Boolean,
      default: true,
    },
    contentPadding: {
      type: String,
      default: 'p-6'
    }
  }
}
</script>